import { SxProps, Theme } from '@mui/material'

export const taskGridSxProps = (theme: Theme) => {
  {
    const gridSxProps: SxProps<Theme> = {
      '& .MuiDataGrid-cell': {
        padding: '0px', // You already removed internal padding
      },
      '& .MuiDataGrid-columnHeaders': {
        borderBottom: 'none',
      },
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        padding: '0px',
      },
      '& .creative-row-border': {
        borderLeft: `4px solid ${theme.palette?.icon?.creative} !important`,
      },
      '& .marketing-row-border': {
        borderLeft: `4px solid ${theme.palette?.icon?.nco} !important`,
      },
      '& .website-row-border': {
        borderLeft: `4px solid ${theme.palette?.icon?.website} !important`,
      },
      '& .high-priority-row-creative-row-border': {
        backgroundColor: 'rgba(255, 0, 0, 0.1)',
      },
      '& .high-priority-row-marketing-row-border': {
        backgroundColor: 'rgba(255, 0, 0, 0.1)',
      },
      '& .subtask-row': {
        backgroundColor: theme.palette.background.subtasksection,
        // fontStyle: 'italic',
        border: 'none',
        color: theme.palette.text.secondary, // lighter gray
        opacity: 0.85,
        cursor: 'default',
        pl: 0,
        borderLeft: `4px solid ${theme.palette.text.primary} !important`,
        '&:hover': {
          // backgroundColor: theme.palette.background.paper, // disable hover effect
          backgroundColor: theme.palette.background.section, // disable hover effect
        },

        '& .MuiDataGrid-cell': {
          borderBottom: 'none',
          paddingTop: '2px',
          paddingBottom: '2px',
        },
      },
      '& .postdated': {
        backgroundColor: `${theme.palette.background.postdated} !important`,
        '&:hover': {
          backgroundColor: `${theme.palette.background.postdated} !important`,
        },
        '& .MuiDataGrid-cell': {
          backgroundColor: 'inherit !important',
          '&:hover': {
            backgroundColor: 'inherit !important',
          },
        },
      },
      '& .MuiDataGrid-cell[data-field="__tree_data_group__"]': {
        display: 'none',
      },
      '& .MuiDataGrid-cell[data-field="assigneeNames"]': {
        display: 'none',
      },
      '& .MuiDataGrid-columnHeader[data-field="assigneeNames"]': {
        display: 'none',
      },
      '& .grouping-header': { display: 'none' },
      // '& .MuiDataGrid-row.subtask-row .MuiDataGrid-cellCheckbox': {
      //   display: 'none',
      // },
      '& .MuiDataGrid-row .MuiDataGrid-cellCheckbox': {
        zIndex: 1500,
      },
      '& .pinned-row MuiDataGrid-row': {
        bgcolor: 'red',
      },
    }
    return gridSxProps
  }
}
